import React, { useCallback, useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

const search = (query, index) => {
  if (query[0] == "#") {
    var i = parseInt(query.slice(1));
    if (i) {
      return [index[i]];
    }
  }

  if (query.length < 2) {
    return [];
  }

  return index.filter((item) => {
    var show = item.name.toLowerCase().includes(query.toLowerCase());
    if (show || !(item.keywords && item.keywords.length > 0)) {
      return show;
    } else {
      for (let keyword of item.keywords) {
        if (keyword.toLowerCase().includes(query.toLowerCase())) {
          return true;
        }
      }
      return false;
    }
  });
};

function SuperSearch({ defaultIndex = [] }) {
  const navigate = useNavigate();
  const [isOpen, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [index, setIndex] = useState(defaultIndex);

  useEffect(() => {
    setSearchResults(search(query, index));
  }, [query, index]);

  const onKeydownCallback = useCallback(
    (ev) => {
      if (ev.key === "k" && ev.ctrlKey) {
        ev.preventDefault(); // Prevent browser default
        setOpen(!isOpen);
      }

      if (isOpen) {
        if (ev.key === "Escape") {
          ev.preventDefault(); // Prevent browser default
          setOpen(false);
          setQuery("");
        }

        if (ev.key === "Enter") {
          ev.preventDefault(); // Prevent browser default
          if (searchResults.length > 0) {
            setOpen(false);
            setQuery("");
            navigate(searchResults[0].url);
          }
        }
      }
    },
    [isOpen, searchResults]
  );

  useEffect(() => {
    if (isOpen) {
      document.getElementById("searchInput").focus();
    } else {
      document.getElementById("searchInput").blur();
    }

    window.addEventListener("keydown", onKeydownCallback);

    return () => {
      window.removeEventListener("keydown", onKeydownCallback);
    };
  }, [isOpen, searchResults]);

  return (
    <div
      className={
        "w-screen h-screen fixed top-0 left-0 z-50 flex items-center justify-center transition-all duration-200 " +
        (isOpen
          ? "opacity-1 pointer-events-all backdrop-blur-md"
          : "opacity-0 pointer-events-none backdrop-blur-0")
      }
    >
      <div className="p-8 flex flex-col gap-16 w-1/3 items-center justify-center">
        <h1 className="font-bold text-4xl text-primary">Search Mentostar</h1>
        <TextField
          variant="standard"
          placeholder="Type or Press Ctrl+K"
          fullWidth
          focused
          autoFocus
          id="searchInput"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
          }}
        />
        <div className="w-full">
          {searchResults.map((item) => {
            return (
              <div
                className="w-full bg-gray-100 p-2 my-2 rounded-md text-sm flex transition-all cursor-pointer"
                onClick={() => {
                  setOpen(false);
                  setQuery("");
                  navigate(item.url);
                }}
              >
                <span className="flex-grow text-gray-600 font-bold">
                  {item.name}
                </span>
                <span className="text-gray-500 text-xsm">{item.url}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default SuperSearch;
